exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-card {\n  height: 90vh; }\n  .modal-card .select.is-fullwidth {\n    height: 100%; }\n  .modal-card .select:not(.is-multiple):not(.is-loading)::after {\n    display: none !important;\n    background: red; }\n\n#controlRegion {\n  padding: 5px 0;\n  border: 1px solid #33333326;\n  height: 33vh;\n  overflow: auto; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/component/region-detail-modal/modalCard.scss
// module id = 1483
// module chunks = 0